<template>
  <div class="item" :class="{open: open}">
    <div class="opener" v-on:click="open = !open"><slot name="header"></slot></div>
    <div class="para"><slot></slot></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      open: false
    }
  }
}
</script>

<style>
.quote-panel .rhs .item {
  border-bottom:1px solid #ccc;
  padding-bottom:10px;
  margin-bottom:8px;
}
.para{
  color:#6d6d64;
  opacity:0;
  z-index:0;
  transition:all 0.2s ease;
  max-height:0;
  padding-left:12px;
}
.open .para{
  opacity:1;
  max-height:60px;
  padding-top:3px;
}

.opener{
  padding-left:12px;
  position: relative;
  cursor:pointer;
  z-index:5;
}

.opener:hover{
  color:#ce0e2d;
}

.opener::before{
  content:"";
  position:absolute;
  background-image:url('../../../assets/img/arrow-right.svg');
  background-position:left center;
  background-size:7px;
  top:3px;
  left:0;
  width:12px;
  height:12px;
  background-repeat:no-repeat;
  transition:all 0.2s ease;
}

.open .opener::before{
  top:6px;
  left:-3px;
  transform:rotate(90deg);
}


</style>